export enum NAVBAR_ITEMS {
  ABOUT = 'aboutMeSection',
  REVIEW = 'reviewSection',
  ARTICLE = 'articlesSection',
  COMPANY = 'companySection',
  PRODUCTS = 'legalProductsSection',
  CONTACT = 'kontakt',
  FAQ = 'faqSection',
}
